var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgM3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 546,
    height: 1163,
    viewBox: "0 0 546 1163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "m-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M336.374 962.822C343.034 913.199 336.374 824.276 392.488 745.509C434.872 694.715 476.365 640.479 476.651 571.27C480.943 461.348 386.843 357.926 269.383 369.223C208.319 375.097 167.985 400.002 125.909 410.363C103.682 415.835 128.12 442.904 144.122 449.613C192.582 469.935 215.402 440.506 267.21 435.797C324.409 430.597 385.508 470.9 402.231 526.859C419.056 580.931 393.898 630.005 360.324 671.799C301.112 745.509 272.52 827.946 269.361 940.375C264.815 958.031 261.502 977.682 265.811 995.839C271.81 1025.25 308.622 1037.99 325.607 1010.46C332.753 998.839 334.081 984.578 336.374 971.158C337.925 961.415 332.548 972 336.342 962.889L336.37 962.826L336.374 962.822Z",
    fill: "#DB9CF3",
    stroke: "#A7599C",
    strokeWidth: 6.05347,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M188.706 449.614C194.083 449.614 198.442 445.255 198.442 439.878C198.442 434.501 194.083 430.143 188.706 430.143C183.33 430.143 178.971 434.501 178.971 439.878C178.971 445.255 183.33 449.614 188.706 449.614Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M188.708 444.119C191.049 444.119 192.947 442.221 192.947 439.88C192.947 437.539 191.049 435.641 188.708 435.641C186.367 435.641 184.469 437.539 184.469 439.88C184.469 442.221 186.367 444.119 188.708 444.119Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M161.075 446.007C164.63 446.007 167.511 443.126 167.511 439.571C167.511 436.016 164.63 433.135 161.075 433.135C157.52 433.135 154.639 436.016 154.639 439.571C154.639 443.126 157.52 446.007 161.075 446.007Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M161.076 442.379C162.625 442.379 163.881 441.123 163.881 439.574C163.881 438.025 162.625 436.77 161.076 436.77C159.527 436.77 158.271 438.025 158.271 439.574C158.271 441.123 159.527 442.379 161.076 442.379Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M243.538 430.694C246.876 430.694 249.582 427.988 249.582 424.65C249.582 421.312 246.876 418.605 243.538 418.605C240.2 418.605 237.494 421.312 237.494 424.65C237.494 427.988 240.2 430.694 243.538 430.694Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M243.54 427.285C244.993 427.285 246.172 426.107 246.172 424.653C246.172 423.2 244.993 422.021 243.54 422.021C242.086 422.021 240.908 423.2 240.908 424.653C240.908 426.107 242.086 427.285 243.54 427.285Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M216.589 438.85C220.528 438.85 223.721 435.657 223.721 431.718C223.721 427.779 220.528 424.586 216.589 424.586C212.65 424.586 209.457 427.779 209.457 431.718C209.457 435.657 212.65 438.85 216.589 438.85Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M216.589 434.823C218.304 434.823 219.695 433.433 219.695 431.718C219.695 430.003 218.304 428.613 216.589 428.613C214.875 428.613 213.484 430.003 213.484 431.718C213.484 433.433 214.875 434.823 216.589 434.823Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM3);
export default __webpack_public_path__ + "static/media/m-3.93d774a22f724d96f4641377ba3a3530.svg";
export { ForwardRef as ReactComponent };